/**
 * Copyright (c) 2025 Kalpit Patel
 *
 * Sole Developer and Owner:
 * Kalpit Patel is the sole developer and creator of this entire application.
 * No other individual or entity has contributed to the development of this software.
 * All rights reserved.
 *
 * This file is part of AksharJobs application.
 */

import React from 'react';
import '../styles/ImprovedLoading.css';

/**
 * Modern Loading Spinner - Fast, Smooth, Minimal & Attractive
 * 
 * @param {string} size - 'small', 'medium', 'large'
 * @param {string} text - Loading text to display
 * @param {string} type - 'spinner', 'dots', 'progress', 'pulse', 'ring'
 * @param {boolean} overlay - Show as full-page overlay
 * @param {boolean} showText - Show loading text
 */
const ModernLoadingSpinner = ({ 
  size = 'medium', 
  text = '', 
  type = 'spinner',
  overlay = false,
  dark = false,
  showText = true
}) => {
  
  const renderLoader = () => {
    switch (type) {
      case 'dots':
        return (
          <div className="modern-loading-dots">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        );
      
      case 'progress':
        return (
          <div className="modern-progress-bar">
            <div className="modern-progress-fill"></div>
          </div>
        );
      
      case 'pulse':
        return (
          <div className={`modern-loading-pulse ${size}`}>
            <div className="pulse-ring"></div>
            <div className="pulse-core"></div>
          </div>
        );
      
      case 'ring':
        return (
          <div className={`modern-loading-ring ${size}`}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        );
      
      case 'spinner':
      default:
        return (
          <div className={`modern-loading-spinner ${size}`}></div>
        );
    }
  };

  const content = (
    <div className="modern-loading-container">
      {renderLoader()}
      {showText && text && <p className="modern-loading-text">{text}</p>}
    </div>
  );

  if (overlay) {
    return (
      <div className={`modern-page-overlay ${dark ? 'dark' : ''}`}>
        {content}
      </div>
    );
  }

  return content;
};

export default ModernLoadingSpinner;

